import { Col, Row } from 'react-bootstrap';
import { Field } from 'redux-form';
import { CheckboxGroup } from '../../../../common/components/ReduxFormField';
import React from 'react';

const UpdateSchemeField = ({ input }) => {
  const { name, version, status } = input.value;
  const label = `${name} v${version} - ${status}`;
  return (
    <Col sm={12}>
      <Field
        name={`${input.name}.enabled`}
        options={[{ label: label, value: true }]}
        inline
        component={CheckboxGroup}
      />
    </Col>
  );
};

export const UpdateSchemesFieldArray = ({ fields }) => {
  return (
    <Row>
      <h2>Select Schemes to Update</h2>
      {fields.map((field) => (
        <Field name={field} component={UpdateSchemeField} />
      ))}
    </Row>
  );
};
